<template>
  <div v-if="syncedVisible">
    <DialogBase
      v-model="syncedVisible"
      :title="$t('sale.sale_bulk-completion-operation')"
      :isFooter="false"
      :width="width"
      :isCardColor="true"
    >
      <template #title="{ dialogTitle }">
        <span class="pl-5 py-2 dialogTitleStyle">
          {{ dialogTitle }}
        </span>
      </template>

      <v-container fluid class="pa-2 baseStyle">
        <v-row>
          <v-col>
            <ExpansionPanel :open="true" class="border rounded-lg">
              <template #header>
                <span class="font-weight-bold py-4 tableTitleStyle">
                  {{ $t('sale.sale_bulk-completion') }}
                </span>
              </template>
              <template #content>
                <div class="px-9 py-7">
                  <p v-if="checkedIdList.length > 0" class="mb-2">
                    {{ checkedIdList.length
                    }}{{ $t('payment.payment_sale-selected') }}
                  </p>
                  <p v-else class="mb-2">
                    {{ $t('payment.payment_sale-not-selected') }}
                  </p>
                  <p>{{ $t('sale.sale_bulkorder-not-sale-applicable') }}</p>
                  <div class="yCenter">
                    <span>{{ $t('sale.sale_sale-payment-date') }}</span>
                    <NormalDatePicker
                      class="pl-4 pr-7"
                      width="137px"
                      v-model="date"
                    />

                    <span>{{ $t('payment.payment_sale-payment-method') }}</span>
                    <SelectPaymentMethod
                      class="pl-4 paymentMethod"
                      v-model="paymentMethod.value"
                      :key="paymentMethod.key"
                    />

                    <NormalTextButton
                      :text="$t('payment.payment_sale-payment-method-register')"
                      @click="paymentMethod.dialog = true"
                    />
                    <MasterPaymentMethodDialog
                      v-model="paymentMethod.dialog"
                      @success="successPaymentMethod"
                    />

                    <span class="ml-4">{{
                      $t('sale.sale_completion-date')
                    }}</span>
                    <NormalDatePicker
                      class="pl-4 pr-7"
                      width="137px"
                      v-model="completeDate"
                    />

                    <NormalButton
                      class="btnStyle ml-2 mr-4"
                      :text="$t('sale.sale_completion')"
                      height="32px"
                      width="90px"
                      @click="register()"
                    />
                  </div>
                </div>
              </template>
            </ExpansionPanel>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ExpansionPanel :open="true" class="border rounded-lg">
              <template #header>
                <span class="font-weight-bold py-4 tableTitleStyle">
                  {{ $t('payment.payment_total-deposit-status') }}
                </span>
              </template>
              <template #content>
                <TotalDepositAndWithdrawalStatusTable
                  :items="status.items"
                  :headers="status.headers"
                  paymentType="sale"
                />
              </template>
            </ExpansionPanel>
          </v-col>
        </v-row>
      </v-container>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from './DialogBase'
import {
  NormalButton,
  ExpansionPanel,
  SelectPaymentMethod,
  NormalTextButton
} from '@/components/items'
import { productMovesUtil, currencyUtil } from '@/util'
import { mapActions, mapGetters } from 'vuex'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import TotalDepositAndWithdrawalStatusTable from '@/components/items/Tables/TotalDepositAndWithdrawalStatusTable'
import MasterPaymentMethodDialog from '@/components/layouts/Dialogs/Master/PaymentMethod/MasterPaymentMethodDialog'

export default {
  components: {
    NormalButton,
    NormalTextButton,
    DialogBase,
    ExpansionPanel,
    NormalDatePicker,
    TotalDepositAndWithdrawalStatusTable,
    SelectPaymentMethod,
    MasterPaymentMethodDialog
  },
  props: {
    visible: { default: false },
    width: { default: '1166px' },
    items: [],
    historyList: []
  },
  data: () => ({
    syncedVisible: false,
    date: null,
    completeDate: null,
    paymentMethod: {
      value: null,
      dialog: false,
      key: 0
    },
    status: {
      items: [],
      headers: [
        {
          text: 'common.input_currency',
          value: 'currencyUnit',
          sortable: false,
          width: '12%'
        },
        {
          text: 'payment.payment_total-price-no-colon',
          value: 'totalAmount',
          sortable: false,
          width: '15%'
        },
        {
          text: 'payment.payment_total-saled-payment-price',
          value: 'totalDoneAmount',
          sortable: false,
          width: '15%'
        },
        {
          text: 'payment.payment_total-not-sale-payment-price',
          value: 'totalStillAmount',
          sortable: false,
          width: ''
        }
      ]
    }
  }),
  methods: {
    ...mapActions('Sale', ['getSaleDetailFromApi', 'registerSalesComplete']),
    ...mapGetters('Sale', ['getSaleDetailFromState']),
    ...mapActions('Common', ['setIsLoading']),
    async getData() {
      if (this.checkedIdList.length <= 0) return
      const saleIds = this.checkedIdList.join(',')
      await this.getSaleDetailFromApi({ saleIds })

      const saleDetailList = this.getSaleDetailFromState()
      const items = []
      for (const detail of saleDetailList) {
        // 初登場の通貨であれば配列追加
        if (!items.find((item) => item.currencyId === detail.sale.currencyId)) {
          items.push({
            currencyId: detail.sale.currencyId,
            currencyUnit: currencyUtil.findCurrencyNameById(
              detail.sale.currencyId
            ).name, // 通貨名
            totalAmount: 0, // 合計金額
            totalDoneAmount: 0, // 合計入金済金額
            totalStillAmount: 0 // 合計未入金金額
          })
        }

        const targetItem = items.find(
          (item) => item.currencyId === detail.sale.currencyId
        )
        targetItem.totalAmount += this.getAmount(detail.sale)
        detail.paidList.forEach((paidItem) => {
          targetItem.totalDoneAmount += Number(paidItem.amount)
        })
        targetItem.totalStillAmount =
          targetItem.totalAmount - targetItem.totalDoneAmount
      }
      this.status.items = items
    },
    successPaymentMethod() {
      this.paymentMethod.dialog = false
      this.paymentMethod.key = this.paymentMethod.key ? 0 : 1
    },
    getAmount(rec) {
      const ret = productMovesUtil.getTotalAmountAndUnit(
        rec.productMoves,
        rec.currencyId
      )
      const addAmount =
        Number(rec.consumptionTax10) +
        Number(rec.consumptionTax8) -
        Number(rec.discount) +
        Number(rec.comission)
      const amount = ret.amount + addAmount

      return amount
    },
    async register() {
      this.setIsLoading(true)
      const isConfirmed = confirm(
        this.$t('payment.payment_sale-payment-save-question')
      )
      if (isConfirmed) {
        const isSucceed = await this.registerSalesComplete({
          saleList: this.checkedIdList.map((id) => {
            return { saleId: id }
          }),
          date: this.date,
          completeDate: this.completeDate,
          method: this.paymentMethod.value
        })
        if (isSucceed) {
          this.$emit('update:visible', false)
        }
      }
      this.setIsLoading(false)
    }
  },
  computed: {
    checkedIdList() {
      const idList = this.items
        .filter((item) => item.checkFlg)
        .map((item) => item.id)

      return idList
    }
  },
  watch: {
    visible(val) {
      this.syncedVisible = val
      if (val) {
        this.getData()
      } else {
        this.status.items = []
      }
    },
    syncedVisible(val) {
      this.$emit('update:visible', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
.dialogTitleStyle {
  font-size: 22px;
}
.tableTitleStyle {
  padding-left: 30px;
  font-size: 15px;
}
.tableSubTitleStyle {
  font-size: 13px;
}
.border {
  border: 1px solid #d8d8d8 !important;
}
.paymentMethod {
  width: 150px;
}
</style>
